module.exports = __webpack_public_path__ + "img/zoom_out.bbff41a5.svg";